export enum CreatorTypeEnum {
  CONSULTANT = 'CONSULTANT',
  INTERN = 'INTERN'
}
